module.exports = __webpack_public_path__ + "static/media/icons-ic-callback-transfer.9b463e38.svg";